import { Component, ElementRef, OnInit, SecurityContext, ViewChild, ViewEncapsulation } from '@angular/core'
import { Lab, UiPreferences } from '../../../../api/models'
import { UntypedFormBuilder } from '@angular/forms'
import { AppSettingService, LabsService } from '../../../../api/services'
import { MessageService, ConfirmationService } from 'primeng/api'
import { Router, ActivatedRoute } from '@angular/router'
import { Customsort } from '../../../directives/customsort'
import { DomSanitizer, SafeHtml, SafeStyle } from '@angular/platform-browser'
import { LabDetailsComponent } from './lab-details/lab-details.component'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { environment } from '../../../../../environments/environment'
//import 'chartjs-adapter-luxon'; // Import the adapter for luxon

import * as html2pdf from 'html2pdf.js';


@Component({
  selector: 'app-lab-list',
  templateUrl: './lab-list.component.html',
  styleUrls: ['./lab-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LabListComponent implements OnInit {
  Item = 'Labs'
  distinctLabList: Array<Lab>
  arrlabdetails: string[]
  distinctLabTest: any
  selectedPatient: Lab
    cols: any[]
   

  orderclass: any
  rows: number
  HeaderCol: string[]
  LinkStyle: SafeStyle
  blockStyle: string = 'N'
  displaychartstypepopup: boolean = false
  popupheader: string = ''
  graphdata: any
  popupDisplayDetails: boolean = false

  titleLabDetails: string = ''
  testName
  patientFullName
    showPatientDemographicPrint: boolean = false

    preferences: UiPreferences = {};
    setPrintFlag: boolean = false;

   

    printLayoutDesign: boolean = false;

    printlayout: string ='layout1';

    @ViewChild('printSection', { static: false }) printSection!: ElementRef;

    sanitizedTestName: SafeHtml;
    isDownloadVisiableOnList: boolean = false;
  constructor(
    private fb: UntypedFormBuilder,
    private labservice: LabsService,
    private messageService: MessageService,
    private confirmation: ConfirmationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cstsort: Customsort,
    protected sanitizer: DomSanitizer,
    private appSetting: AppSettingService,
    private domSanitizer: DomSanitizer,
  ) {}

  @ViewChild('labDetails')
  labDetailsComponent!: LabDetailsComponent

  ngOnInit() {
    this.patientFullName = sessionStorage.getItem('ptName')
    this.LoaddistinctLabList()

    this.appSetting
      .appSettingGetPracticeSettings$Response()
      .subscribe((res) => {
          this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;
         

          if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
              this.setPrintFlag = true;
          }
          else {
              this.setPrintFlag = false;
          }
      })

     

      const storedPreferences = localStorage.getItem('uiPreferences');
      if (storedPreferences) {
          this.preferences = JSON.parse(storedPreferences);

          this.Item = this.preferences?.labs || 'Labs';
      }
  }
  LoaddistinctLabList(): void {
    this.labservice
      .labsGetDistinctTest({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
      })
      .subscribe((result) => {
        this.distinctLabList = result

          if (result.length > 0)
          {
              this.loadlabList(1, '', result[0].testName);
             
         }

        this.distinctLabTest = this.distinctLabList[0]
      })


     
     
  }
  setViews(item, obrid, testname) {
    debugger
    if (item == null) {
      return ''
    } else if (item.indexOf('|') > -1) {
      this.HeaderCol = item.split('|')
      switch (this.HeaderCol.length) {
        case 3:
          if (
            this.HeaderCol[2].toString() == 'Y' &&
            this.HeaderCol[0].length > 0
          ) {
            var _obrid = obrid.split('|')
            if (_obrid == null && _obrid.length == 0) {
              _obrid = ''
            }
            debugger
            this.navigateToDetails(testname, _obrid)
          }

          break

        case 5:
          if (
            this.HeaderCol[2].toString() == 'Y' &&
            this.HeaderCol[0].length > 0
          ) {
            // alert(5);
          }
          break

        default:
          return false
      }
    }
  }
  loadlabList(pageNumber: number, sortbydirection: string, testName: string) {
      if (typeof testName === 'object' && testName !== null) {
          // testName is an object (and not null)
          this.testName = testName

          this.sanitizedTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.testName?.testName || '');
      }
      else
      {
          this.testName = {};
          this.testName.testName = testName;
           this.sanitizedTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.testName?.testName || '');
      }   
      this.labservice
          .labsList({
              patientId: sessionStorage.getItem('ptId'),
              emrpracticeId: localStorage.getItem('EmrPracticeId'),
              pageNumber: pageNumber,
              sortbydirection: sortbydirection,
              TestName: testName,
          })
          .subscribe((result) => {
              if (result.length > 0) {
                  var objJson1 = JSON.parse(result)
                  //  console.log(objJson1);
                  debugger
                  this.arrlabdetails = objJson1

                  this.cols = [];
                  for (var key in objJson1[0]) {
                      if (this.cols.indexOf(key) === -1) {
                          this.cols.push({ field: key, header: key })
                      }
                  }
                  if (this.cols?.length < 10) {
                      this.isDownloadVisiableOnList = true;
                  }
                  else {
                      this.isDownloadVisiableOnList = false;
                  }
              }
          });      
  }

  Setlabitem() {
    // console.log(this.distinctLabTest);
    this.loadlabList(1, '', this.distinctLabTest)

      this.testName = this.distinctLabTest;

      this.sanitizedTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.testName?.testName || '');


  }

  Getheader(item) {
    if (item.indexOf('|') > -1) {
      this.HeaderCol = item.split('|')
      return this.HeaderCol[0].toString()
    } else {
      return item
    }
  }

  setSeverity(item): string {
    if (item == null) {
      return 'secondary'
    } else if (item.indexOf('|') > -1) {
      this.HeaderCol = item.split('|')
      if (
        this.HeaderCol[1] != null &&
        this.HeaderCol[1].toString() != '' &&
        this.HeaderCol[1].toString() + '' != ''
      ) {
        var Flag = this.HeaderCol[1].toString().toUpperCase()

        if (
          Flag == 'HIGH' ||
          Flag == 'H' ||
          Flag == 'A' ||
          Flag == 'BH' ||
          Flag == 'HH' ||
          Flag == 'PH'
        ) {
          this.LinkStyle = 'color:black;display:block'
          return 'p-badge p-badge-danger ' + this.selectCursor(item)
        }

        if (
          Flag == 'LOW' ||
          Flag == 'L' ||
          Flag == 'BL' ||
          Flag == 'LL' ||
          Flag == 'PL'
        ) {
          this.LinkStyle = 'color:#F7F3F3;display:block'
          return 'p-badge p-badge-info ' + this.selectCursor(item)
        }
        if (Flag == 'N') {
          this.LinkStyle = 'color:black;display:block'
          return ''
        }
      }
    }
  }

  selectCursor(item): string {
    if (item == null) {
      return 'cursorDefault'
    } else if (item.indexOf('|') > -1) {
      this.HeaderCol = item.split('|')
      switch (this.HeaderCol.length) {
        case 3:
          if (
            this.HeaderCol[2].toString() == 'Y' &&
            this.HeaderCol[0].length > 0
          ) {
            return 'cursorPointer textUnderline'
          }
          break

        case 5:
          if (
            this.HeaderCol[2].toString() == 'Y' &&
            this.HeaderCol[0].length > 0
          ) {
            return 'cursorPointer textUnderline'
          }
          break

        default:
          return 'cursorDefault'
      }
    } else {
      return 'cursorDefault'
    }
  }

  labels: any = []
  yearCount: any = []
  uniqueYears: any = []
  getgraphDetails(item) {
    this.displaychartstypepopup = true

    var firstKey = Object.keys(item)[0]
    var firstvalue = Object.values(item)[0].toString()
    this.labservice
      .labsGetGraphForlab({
        EmrpracticeId: localStorage.getItem('EmrPracticeId'),
        PatientId: sessionStorage.getItem('ptId'),
        SelectedTest: firstKey,
        Labname: firstvalue,
      })
      .subscribe((result) => {
        let rollingLabel
        // Extract years and prepare data for Chart.js
        this.labels = result.graphList.map((y) => new Date(y.date))
        const data = result.graphList.map((y) => y.graphValue)

        //// Prepare data for Chart.js
        //const data = result.graphList.map(y => ({
        //    x: new Date(y.date).getFullYear().toString(),
        //    y: y.graphValue
        //}));

        //const labels = [...new Set(data.map(d => d.x))];

        this.graphdata = {
          labels: this.labels,
          datasets: [
            {
              label: item[this.cols[0].header],
              data: data,
              fill: false,
              borderColor: '#42A5F5',
              tension: 0.3,
              //options: this.chartOptions
            },
          ],
        }
      })
  }

  public rollingLabel

  // Define chart options
  public chartOptions: any = {
    scales: {
      x: {
        type: 'time',

        time: {
          unit: 'year',
        },

        //type: 'time',
        //time: {
        //    display: true,
        //    unit: 'year'
        //    ,stepSize: 1 // Ensures consistent yearly gaps
        //},

        //title: {
        //    display: true,
        //    text: 'Year'
        //},
        //grid: {
        //    display: false // Hide x-axis grid lines
        //},
        grid: {
          drawOnChartArea: true,
          color: (context) => {
            const isYearStart = context.tick?.label
            return isYearStart != ' ' ? '#ededed' : '' // Bold line color for year start, lighter for others
          },
          lineWidth: (context) => {
            const isYearStart = context.tick?.label
            return isYearStart != ' ' ? 3 : 1 // Bold line width for year start
          },
        },
        /*                ticks: {

                    display: true,
                    autoSkip: false,
                    callback: function (label, index, ticks) {

                        // Create a map to count occurrences of each year
                        this.yearCount = this.chart.config._config.data.labels.reduce((count, year) => {
                            count[year] = (count[year] || 0) + 1;
                            return count;
                        }, {});


                        this.uniqueYears = [];
                        // Iterate over each label (year)
                        for (let i = 0; i < this.chart.config._config.data.labels.length; i++) {
                            const year = this.chart.config._config.data.labels[i];

                            // Check if the count of the year is greater than 1
                            if (this.yearCount[year] >= 1) {
                                if (this.uniqueYears.indexOf(year) >= 1 && i != 0) {
                                    this.uniqueYears.push(' ');
                                }
                                else {
                                    // If the count is 1 or less, add the year to uniqueYears
                                    this.uniqueYears.push(year);
                                }

                            } else {
                                // Otherwise, add an empty string
                                this.uniqueYears.push(' ');
                            }
                        }


                        // Show the tick label if it's a unique year; otherwise, show an empty string
                        if (this.uniqueYears) {
                            return this.uniqueYears[index] || '';
                        }

                    }
                }
*/

        ////autoSkip: false, // Ensures all years are displayed
        ////callback: function (value) {
        ////    return new Date(value).getFullYear();
        ////}

        //, min: new Date('2004-01-01').getTime() // Set the minimum year
        //, max: new Date('2010-12-31').getTime()  // Set the maximum year
      },

      //y: {
      //    grid: {
      //        display: false // Hide y-axis grid lines
      //    }
      //}
    }, // scale

    plugins: {
      tooltip: {
        enabled: false,
        //callbacks: {
        //    label: function (context) {
        //        // Return only the y-value, which is the value of the data point
        //        return context.raw.y;
        //    },
        //},
      },
    }, //plugins
  } //chartOptions

  Getfield(item) {
    if (item == null) {
      return ''
    }
    if (item.indexOf('NOT') > -1) {
      return 'NA'
    }
    if (item.indexOf('|') > -1) {
      this.HeaderCol = item.split('|')

      return this.HeaderCol[0].toString()
    } else {
      return item
    }
  }

  navigateToDetails(tname: any, _id: any) {
    this.titleLabDetails = tname[this.cols[0].header]
    this.labDetailsComponent.testName = this.titleLabDetails
    this.labDetailsComponent.obrid = _id[1]
    this.labDetailsComponent.loadlabdetails(1, 'Desc')
    this.labDetailsComponent.onViewComments()
    this.popupDisplayDetails = true
  }

  

    onFocus() {
      
        setTimeout(() => {
           
            const dropdownPanels = document.getElementsByClassName('p-dropdown-panel p-component ng-star-inserted') as HTMLCollectionOf<HTMLElement>;

            
            if (dropdownPanels.length > 0) {
                const dropdownPanel = dropdownPanels[0]; // Access the first element
                /*dropdownPanel.style.overflowY = 'scroll';*/

                dropdownPanel.style.height = '100% !important';
                dropdownPanel.style.maxHeight = '100%';


                const innerDiv = document.getElementsByClassName('p-dropdown-items-wrapper') as HTMLCollectionOf<HTMLElement>;

                if (innerDiv.length > 0) {

                    const innerDiv1 = innerDiv[0]; // Access the first element

                    let x = 550 + (this.distinctLabList.length * 1);
                    let p = x + 'px';

                   // alert(p);
                    innerDiv1.style.maxHeight = p; //'600px'; // Set your desired max-height value
                    innerDiv1.style.overflowY = 'scroll';

                    //innerDiv1.style.removeProperty('max-height'); // or use dropdownPanel.style.maxHeight = ''; to clear it
                }

               
            }
        });
    }




    //# :: Print Functionaliy::

     // Colummn less then 10(Ten) Design Layout Design::
    printLabs() {
        if (this.cols.length > 10)
        {
            // this.printLayoutDesign = true;
            this.printLabs_ColumnBreak();
        }
        else
        {
            var PrintLabs = document.getElementById('PrintLabs_List') as HTMLElement
            const printWindow = window.open('', '_blank')
            if (printWindow) {
                const divContent = PrintLabs.innerHTML
                printWindow.document.open()
                printWindow.document.write('<html><head><title>Print::Labs List</title>')
                // Adding CSS styling for alternate rows
                printWindow.document.write('<style type="text/css">')
                printWindow.document.write(
                    '    #Labs_print_table_tbody tbody tr:nth-child(odd) {',
                )
                printWindow.document.write('        background-color: #f2f2f2;')
                printWindow.document.write('    }')
                printWindow.document.write(
                    '    #Labs_print_table_tbody tbody tr:nth-child(even) {',
                )
                printWindow.document.write('        background-color: #e6e6e6;')
                printWindow.document.write('    }')
                printWindow.document.write('</style>')
                printWindow.document.write('</head><body>')
                printWindow.document.write(divContent)
                printWindow.document.write('</body><html>')
                printWindow.document.close()
                printWindow.focus()
                printWindow.print()
                printWindow.close()
            } else {
                console.error('Failed to open print window.')
            }

        }

    }
    downloadLabpdf() {


        if (this.cols.length > 10) {
            // this.printLayoutDesign = true;
            this.downloadLabsLayout();
        }
        else {
            const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';
            const filename = `${safeTestName}_ReportLab_${(this.patientFullName || '').trim()}.pdf`;
            let htmlContent;
            htmlContent = this.generatePrintHtml_layout0();
            const container = document.createElement('div');
            container.innerHTML = htmlContent;
            document.body.appendChild(container);
            html2pdf()
                .from(container)
                .set({
                    filename: filename,
                    margin: 10,
                    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                    html2canvas: {
                        scale: 2,
                        useCORS: true,
                        allowTaint: true
                    }
                }).save().then(() => document.body.removeChild(container));
        }
    }
//    generatePrintHtml_layout0(): string {
//        const PrintLabs = document.getElementById('PrintLabs_List') as HTMLElement;
//        if (!PrintLabs) {
//            console.warn('Element with ID "PrintLabs_List" not found.');
//            return '';
//        }
//        const divContent = PrintLabs.innerHTML;
//        // Generate current date-time string
//        const formattedDate = new Date().toLocaleString();
//        // Example patient name — replace with actual value from your component if needed
//        const patientFullName = this.patientFullName || 'Patient Name';
//        const html = `<!DOCTYPE html>
//<html lang="en">
//<head>
//  <meta charset="UTF-8">
//  <title>Print::Labs List</title>
//  <style type="text/css">
//    body {
//      font-family: Arial, sans-serif;
//      font-size: 10pt;
//      margin: 10mm;
//      background-color: #fff;
//    }

//    #printHeader {
//      text-align: center;
//      margin-bottom: 10px;
//    }

//    #printHeader h2 {
//      color: #007BFF;
//      margin: 0;
//    }

//    #printInfo {
//      display: flex;
//      justify-content: space-between;
//      margin-bottom: 10px;
//      font-weight: bold;
//    }

//    table {
//      width: 100%;
//      border-collapse: collapse;
//      margin-bottom: 20px;
//      page-break-inside: avoid;
//    }

//    th {
//      background-color: #142066;
//      color: snow;
//      padding: 6px;
//      border: 1px solid #000;
//      text-align: left;
//    }

//    td {
//      padding: 6px;
//      border: 1px solid #000;
//    }

//    table tbody tr:nth-child(odd) {
//      background-color: #f2f2f2;
//    }

//    table tbody tr:nth-child(even) {
//      background-color: #e6e6e6;
//    }

//    @media print {
//      @page {
//        size: A4 landscape;
//        margin: 10mm;
//      }

//      table, tr, td, th {
//        page-break-inside: avoid;
//        page-break-after: auto;
//      }
//    }
//  </style>
//</head>
//<body>
//  <div id="printHeader">
//    <h4>Labs Report</h2>
//  </div>

//  <div id="printInfo">
//    <div>Patient: ${patientFullName}</div>
//    <div>Printed on: ${formattedDate}</div>
//  </div>
//  ${divContent}

//</body>
//</html>`;
//        return html;
//    }



    generatePrintHtml_layout0(): string {
        const PrintLabs = document.getElementById('PrintLabs_List') as HTMLElement;
        if (!PrintLabs) {
            console.warn('Element with ID "PrintLabs_List" not found.');
            return '';
        }

        const divContent = PrintLabs.innerHTML;
        const formattedDate = new Date().toLocaleString('en-IN', {
            day: '2-digit', month: 'long', year: 'numeric',
            hour: '2-digit', minute: '2-digit',
            hour12: true
        });

        const patientFullName = this.patientFullName || 'Patient Name';

        const html = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Print::Labs List</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      font-size: 10pt;
      margin: 10mm;
      background-color: #fff;
      color: #000;
    }

    #printHeader {
      text-align: center;
      margin-bottom: 10px;
    }

    #printHeader h4 {
      color: #007BFF;
      margin: 0;
      font-size: 10pt;
    }

    #printInfo {
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      font-weight: bold;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 20px;
      table-layout: fixed;
      word-wrap: break-word;
      page-break-inside: avoid;
    }

    th {
      background-color: #142066;
      color: snow;
      padding: 6px;
      border: 1px solid #000;
      text-align: left;
    }

    td {
      padding: 6px;
      border: 1px solid #000;
      vertical-align: top;
    }

    tr:nth-child(odd) {
      background-color: #f2f2f2;
    }

    tr:nth-child(even) {
      background-color: #e6e6e6;
    }

    @media print {
      @page {
        size: A4 landscape;
        margin: 10mm;
      }

      body {
        margin: 0;
      }

      table, tr, td, th {
        page-break-inside: avoid;
        page-break-after: auto;
      }
    }
  </style>
</head>
<body>
  <div id="printHeader">
    <h4>Labs Report</h4>
  </div>

  <div id="printInfo">
    <div>Patient: ${patientFullName}</div>
    <div>Printed on: ${formattedDate}</div>
  </div>

  ${divContent}
</body>
</html>
  `;
        return html;
    }

    // Ends Colummn less then 10(Ten) Design Layout Design::




   // Colummn greater  then 10(Ten) Design Layout Design::

    printLabsLayout() {


        if (this.printlayout == 'layout1') {
            //Columns are split across sections for clarity           
            this.printLabs_ColumnBreak();
        }
        else if (this.printlayout == 'layout2') {
            //Fields are displayed as rows and records as columns for clarity         
            this.printLabs_Transpose();
        }
        else if (this.printlayout == 'layout3') {
            //Fields are displayed as rows and records as columns for clarity[with Css]           
            this.printLabs_Vertical();
        }

        this.printLayoutDesign = false;

    }
   
    printLabs_Transpose(): void {
             
        const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';
        const source = document.getElementById('PrintLabs_List') as HTMLElement | null;
        if (!source) {
            console.error('#PrintLabs_List not found.');
            return;
        }

        // Skip the first row if needed
        const labData = this.arrlabdetails.slice(1);

        // 1. Build header row: first column is "Field", then one column per record
        const headerRow = ['<th>Field</th>', ...labData.map((_, i) => `<th>Value ${i + 1}</th>`)].join('');

        // 2. Build each row as a field name and its values across all records
        const dataRows = this.cols.map(col => {
            const fieldName = this.Getheader(col.header);
            const values = labData.map(item => `<td>${this.Getfield(item[col.field])}</td>`).join('');
            return `<tr><th>${fieldName}</th>${values}</tr>`;
        }).join('');

        const tableHTML = `
    <table class="lab-summary-table">
     
      <tbody>${dataRows}</tbody>
    </table>
  `;

        const now = new Date();
        const formattedDate = now.toLocaleString('en-IN', {
            day: '2-digit', month: 'long', year: 'numeric',
            hour: '2-digit', minute: '2-digit',
            hour12: true
        });

        const html = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <title>Print::Labs List</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          margin: 10mm;
          font-size: 8pt;
          background-color: #fff;
        }
        #timestamp {
          font-style: italic;
          font-size: 7pt;
          margin-bottom: 10px;
        }
        .lab-summary-table {
          width: 100%;
          border-collapse: collapse;
        }
        .lab-summary-table th, .lab-summary-table td {
          border: 1px solid #000;
          padding: 4px;
          text-align: left;
          word-wrap: break-word;
        }
        .lab-summary-table th {
          background-color: #f0f0f0;
        }
        @media print {
          @page {
            size: A4 landscape;
            margin: 10mm;
          }
          body {
            margin: 0;
          }
        }
      </style>
    </head>
    <body>
      <div id="timestamp">Printed on: ${formattedDate}</div>
      <div id="txtpatient" style="font-weight: bold; margin: 6px 0 12px 0;">
        Labs: ${safeTestName} | ${this.patientFullName || ''}
      </div>

      ${tableHTML}
    </body>
    </html>
  `;




        const printWindow = window.open('', '_blank', 'width=1200,height=800');
        if (!printWindow) {
            console.error('Failed to open print window.');
            return;
        }

        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }, 500);
    }
  //  printLabs_ColumnBreak(): void {


  //      /* -------------------------------------------------------
  //       * 1. Basic safety‑check: make sure the element exists
  //       * ----------------------------------------------------- */
  //      const source = document.getElementById('PrintLabs_List') as HTMLElement | null;

  //      if (!source) {
  //          console.error('#PrintLabs_List not found.');
  //          return;
  //      }
  //      const maxColsPerTable = 10;// environment.noOfColumnsInLabList;
  //      const colGroups: { header: string; field: string; width?: string }[][] = [];
  //      for (let i = 0; i < this.cols.length; i += maxColsPerTable) {
  //          colGroups.push(this.cols.slice(i, i + maxColsPerTable));
  //      }

  //      const generateTableHTML = (columns: typeof this.cols, tableId: string) =>
  //      {
  //                const headers = columns.map(col => `<th style="width: ${col.width || (100 / columns.length) + '%'};"> ${this.Getheader(col.header)} </th>`).join('');
  //                const rows = this.arrlabdetails.slice(1).map((item, index) => `<tr>${columns.map(col => `<td>${this.Getfield(item[col.field])}</td>`).join('')}</tr>`).join('');
  //                return `<table id="${tableId}"><thead><tr>${headers}</tr></thead> <tbody>${rows}</tbody></table>`;
  //      };

  //      const tablesHTML = colGroups.map((group, index) => generateTableHTML(group, `Labs_print_table_tbody${index + 1}`)).join('');
  //      const now = new Date();
  //      const formattedDate = now.toLocaleString('en-IN', {  day: '2-digit', month: 'long', year: 'numeric',  hour: '2-digit', minute: '2-digit', hour12: true});

  //      const html = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"> <title>Print::Labs List</title>
  //    <style> body {
  //        font-family: Arial, sans-serif;
  //        margin: 10mm;
  //        font-size: 7pt;
  //        background-color: #fff;
  //      }
  //      #printHeader {
  //        display: flex;
  //        justify-content: space-between;
  //        align-items: center;
  //        margin-bottom: 10px;
  //      }
  //      #printHeader img {
  //        height: 30px;
  //      }
  //      #txtpatient {
  //        display: flex;
  //        justify-content: space-between;
  //        margin-bottom: 10px;
  //        padding: 5px;
  //        font-weight: bold;
  //        font-size: 8pt;
  //      }
  //      #timestamp {
  //        font-style: italic;
  //        font-size: 7pt;
  //        margin-bottom: 10px;
  //        text-align: right;
  //      }
  //      table {
  //        width: 100%;
  //        border-collapse: collapse;
  //        table-layout: fixed;
  //        margin-bottom: 20px;
  //        page-break-inside: avoid;
  //      }
  //      th, td {
  //        border: 1px solid #000;
  //        padding: 3px;
  //        font-size: 7pt;
  //        word-wrap: break-word;
  //        text-align: left;
  //      }
  //      th {
  //        background-color: #d3d3d3;
  //      }
  //      tr:nth-child(odd) {
  //        background-color: #fff;
  //      }
  //      tr:nth-child(even) {
  //        background-color: #f0f0f0;
  //      }
  //      @media print {
  //        @page {
  //          size: A4 landscape;
  //          margin: 10mm;
  //        }
  //        body {
  //          margin: 0;
  //        }
  //        table, tr, td, th {
  //          page-break-inside: avoid;
  //          page-break-after: auto;
  //        }
  //      }
  //    </style>
  //  </head><body>

  //    <div id="printHeader">
  //       <div id="timestamp">Printed on: ${formattedDate}</div>
  //    </div>

  //    <div id="txtpatient">
  //     <div>Labs: ${this.domSanitizer.sanitize(1, this.testName?.testName) || ''}</div>

  //      <div>${this.patientFullName || ''}</div>
  //    </div>
  //    ${tablesHTML}
  //  </body>
  //  </html>
  //`;

  //      const printWindow = window.open('', '_blank', 'width=1200,height=800');
  //      if (!printWindow) {
  //          console.error('Failed to open print window.');
  //          return;
  //      }
  //      printWindow.document.open();
  //      printWindow.document.write(html);
  //      printWindow.document.close();
  //      setTimeout(() => {
  //          printWindow.focus();
  //          printWindow.print();
  //          printWindow.close();
  //      }, 500);
  //  }



    printLabs_ColumnBreak(): void {
        const source = document.getElementById('PrintLabs_List') as HTMLElement | null;

        if (!source) {
            console.error('#PrintLabs_List not found.');
            return;
        }

        const maxColsPerTable = 10;
        const firstCol = this.cols[0]; // First column to be repeated
        const remainingCols = this.cols.slice(1);

        // Chunk remaining columns and prepend the first column to each
        const colGroups: typeof this.cols[][] = [];
        for (let i = 0; i < remainingCols.length; i += maxColsPerTable - 1) {
            const chunk = remainingCols.slice(i, i + (maxColsPerTable - 1));
            colGroups.push([firstCol, ...chunk]); // Repeat first column
        }

        const generateTableHTML = (columns: typeof this.cols, tableId: string) => {
            const headers = columns.map(col =>
                `<th style="width: ${col.width || (100 / columns.length) + '%'};">${this.Getheader(col.header)}</th>`
            ).join('');

            const rows = this.arrlabdetails.slice(1).map(item =>
                `<tr>${columns.map(col =>
                    `<td>${this.Getfield(item[col.field])}</td>`
                ).join('')}</tr>`
            ).join('');

            return `
      <div class="section">
        <table id="${tableId}">
          <thead><tr>${headers}</tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`;
        };

        const tablesHTML = colGroups.map((group, index) =>
            generateTableHTML(group, `Labs_print_table_tbody${index + 1}`)
        ).join('');

        const now = new Date();
        const formattedDate = now.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        const html = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Print::Labs List</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 10mm;
      font-size: 7pt;
      background-color: #fff;
    }

    #printHeader {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    #txtpatient {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      padding: 5px;
      font-weight: bold;
      font-size: 8pt;
    }

    #timestamp {
      font-style: italic;
      font-size: 7pt;
      margin-bottom: 10px;
      text-align: right;
    }

    .section {
      margin-bottom: 12px;
      page-break-inside: avoid;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      margin-bottom: 20px;
      page-break-inside: avoid;
    }

    th, td {
      border: 1px solid #000;
      padding: 3px;
      font-size: 7pt;
      word-wrap: break-word;
      text-align: left;
    }

    th {
      background-color: #d3d3d3;
    }

    tr:nth-child(odd) {
      background-color: #fff;
    }

    tr:nth-child(even) {
      background-color: #f0f0f0;
    }

    @media print {
      @page {
        size: A4 landscape;
        margin: 10mm;
      }
      body {
        margin: 0;
      }
      table, tr, td, th {
        page-break-inside: avoid;
        page-break-after: auto;
      }
    }
  </style>
</head>
<body>
  <div id="printHeader">
    <div id="timestamp">Printed on: ${formattedDate}</div>
  </div>

  <div id="txtpatient">
    <div>Labs: ${this.domSanitizer.sanitize(1, this.testName?.testName) || ''}</div>
    <div>${this.patientFullName || ''}</div>
  </div>

  ${tablesHTML}

 
</body>
</html>`;

        const printWindow = window.open('', '_blank', 'width=1200,height=800');
        if (!printWindow) {
            console.error('Failed to open print window.');
            return;
        }

        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }, 500);
    }


    printLabs_Vertical(): void {

       
        /* -------------------------------------------------------
         * 1. Basic safety‑check: make sure the element exists
         * ----------------------------------------------------- */
        const source = document.getElementById('PrintLabs_List') as HTMLElement | null;
        if (!source) {
            console.error('#PrintLabs_List not found.');
            return;
        }

        /* -------------------------------------------------------
         * 2. Helper that turns ONE record into HTML
         *    - Left  column = field header
         *    - Right column = field value
         * ----------------------------------------------------- */
        const generateRecordHTML = (item: any, recordIndex: number): string =>
        {
            const rows = this.cols.map(col => `
        <tr>
          <th>${this.Getheader(col.header)}</th>
          <td>${this.Getfield(item[col.field])}</td>
        </tr>
      `).join('');

            /* Wrap each record in a div so we get some spacing */
            return `
      <div class="record-block">
       
        <table class="record-table">
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
        };

        /* -------------------------------------------------------
         * 3. Create HTML for EVERY record
         *    slice(1) → skips the very first row if you don’t want it
         * ----------------------------------------------------- */
        const recordsHTML = this.arrlabdetails
            .slice(1)               // remove if you actually need row 0
            .map(generateRecordHTML)
            .join('');

        /* -------------------------------------------------------
         * 4. Common header info: timestamp + patient / test name
         * ----------------------------------------------------- */
        const now = new Date();
        const formattedDate = now.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        /* -------------------------------------------------------
         * 5. Build the COMPLETE HTML document as one template‑literal
         * ----------------------------------------------------- */
        const html = /* html */`
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <title>Print::Labs List</title>
      <style>
        /* ---------- Base styles ---------- */
        body       { font-family: Arial, sans-serif; font-size: 8pt; margin: 10mm; }
        h4         { margin: 0 0 4px 0; font-size: 9pt; }
        .record-block { margin-bottom: 16px; page-break-inside: avoid; }

        /* Table formatting */
        .record-table         { width: 100%; border-collapse: collapse; }
        .record-table th      { width: 30%; background: #f0f0f0; text-align: left; }
        .record-table th,
        .record-table td      { border: 1px solid #000; padding: 4px; word-break: break-word; }

        /* Print settings */
        @media print {
          @page { size: A4 portrait; margin: 10mm; }
          body  { margin: 0; }
          .record-block { page-break-inside: avoid; }
        }
      </style>
    </head>
    <body>
      <div id="timestamp">Printed on: ${formattedDate}</div>
      <div id="txtpatient" style="font-weight:bold; margin:6px 0 12px 0;">

       <span>Labs:${this.domSanitizer.sanitize(1, this.testName?.testName) || ''}</span>

        <span>${this.patientFullName || ''}</span>
      </div>

      ${recordsHTML}
    </body>
    </html>
  `;

        /* -------------------------------------------------------
         * 6. Open new window, write HTML, and print
         * ----------------------------------------------------- */
        const printWindow = window.open('', '_blank', 'width=900,height=1000');
        if (!printWindow) {
            console.error('Failed to open print window.');
            return;
        }

        printWindow.document.open();
        printWindow.document.write(html);
        printWindow.document.close();

        /* wait a short moment so fonts/images finish loading */
        setTimeout(() => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        }, 500);
    }

    downloadLabsLayout() {
        let objorientation = 'portrait';
        const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';
        const filename = `${safeTestName}_ReportLab_${(this.patientFullName || '').trim()}.pdf`;
        let htmlContent;
        if (this.printlayout == 'layout1') {
            //Columns are split across sections for clarity
            htmlContent = this.generatePrintHtml_ColumnBreak();
        }
        else if (this.printlayout == 'layout2') {
            //Fields are displayed as rows and records as columns for clarity
            objorientation = 'landscape';
            htmlContent = this.generatePrintHtml_Transpose();
        }
        else if (this.printlayout == 'layout3') {
            //Fields are displayed as rows and records as columns for clarity[with Css]
            htmlContent = this.generatePrintHtml_Vertical();
        }
        const container = document.createElement('div');
        container.innerHTML = htmlContent;
        document.body.appendChild(container);
        html2pdf()
            .from(container)
            .set({
                filename: filename,
                margin: 10,
                jsPDF: { unit: 'mm', format: 'a4', orientation: objorientation },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true
                }
            }).save().then(() => document.body.removeChild(container));
    }

    //Transpose Layout Design ::
  //  generatePrintHtml_Transpose(): string {
  //      const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';
  //      // Skip the first row if needed
  //      const labData = this.arrlabdetails.slice(1);
  //      // 1. Build header row: first column is "Field", then one column per record
  //      const headerRow = ['<th>Field</th>', ...labData.map((_, i) => `<th>Value ${i + 1}</th>`)].join('');

  //      // 2. Build each row as a field name and its values across all records
  //      const dataRows = this.cols.map(col => {
  //          const fieldName = this.Getheader(col.header);
  //          const values = labData.map(item => `<td>${this.Getfield(item[col.field])}</td>`).join('');
  //          return `<tr><th>${fieldName}</th>${values}</tr>`;
  //      }).join('');

  //      const tableHTML = `
  //  <table class="lab-summary-table">
  //    <tbody>${dataRows}</tbody>
  //  </table>
  //`;
  //      const now = new Date();
  //      const formattedDate = now.toLocaleString('en-IN', {
  //          day: '2-digit', month: 'long', year: 'numeric',
  //          hour: '2-digit', minute: '2-digit',
  //          hour12: true
  //      });
  //      const html = `
  //  <!DOCTYPE html>
  //  <html lang="en">
  //  <head>
  //    <meta charset="UTF-8">
  //    <title>Print::Labs List</title>
  //    <style>
  //      body {
  //        font-family: Arial, sans-serif;
  //        margin: 10mm;
  //        font-size: 8pt;
  //        background-color: #fff;
  //      }
  //      #timestamp {
  //        font-style: italic;
  //        font-size: 7pt;
  //        margin-bottom: 10px;
  //      }
  //      .lab-summary-table {
  //        width: 100%;
  //        border-collapse: collapse;
  //      }
  //      .lab-summary-table th, .lab-summary-table td {
  //        border: 1px solid #000;
  //        padding: 4px;
  //        text-align: left;
  //        word-wrap: break-word;
  //      }
  //      .lab-summary-table th {
  //        background-color: #f0f0f0;
  //      }
  //      @media print {
  //        @page {
  //          size: A4 landscape;
  //          margin: 10mm;
  //        }
  //        body {
  //          margin: 0;
  //        }
  //      }
  //    </style>
  //  </head>
  //  <body>
  //    <div id="timestamp">Printed on: ${formattedDate}</div>
  //    <div id="txtpatient" style="font-weight: bold; margin: 6px 0 12px 0;">
  //      Labs: ${safeTestName || ''} | ${this.patientFullName || ''}
  //    </div>
  //    ${tableHTML}
  //  </body>
  //  </html>
  //`;
  //      return html;


  //  }


    generatePrintHtml_Transpose(): string {
        const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';
        const labData = this.arrlabdetails.slice(1);  // Skip header if needed
         // 2. Build each row as a field name and its values across all records
        const dataRows = this.cols.map(col => {
            const fieldName = this.Getheader(col.header);
            const values = labData.map(item => `<td>${this.Getfield(item[col.field])}</td>`).join('');
            return `<tr><th>${fieldName}</th>${values}</tr>`;
        }).join('');

        const now = new Date();
        const formattedDate = now.toLocaleString('en-IN', {
            day: '2-digit', month: 'long', year: 'numeric',
            hour: '2-digit', minute: '2-digit', hour12: true
        });

        return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Print::Labs List</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 10mm;
      font-size: 8pt;
      background-color: #fff;
    }

    #timestamp {
      font-style: italic;
      font-size: 7pt;
      margin-bottom: 10px;
    }

    .lab-summary-table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      word-wrap: break-word;
    }

    .lab-summary-table th, .lab-summary-table td {
      border: 1px solid #000;
      padding: 4px;
      text-align: left;
      vertical-align: top;
      word-break: break-word;
    }

    .lab-summary-table th {
      background-color: #e6f0ff;
      font-weight: bold;
    }

    #txtpatient {
      font-weight: bold;
      margin: 6px 0 12px 0;
    }

    @media print {
      @page {
        size: A4 landscape;
        margin: 10mm;
      }
      body {
        margin: 0;
      }
    }
  </style>
</head>
<body>
  <div id="timestamp">Printed on: ${formattedDate}</div>
  <div id="txtpatient">
    Labs: ${safeTestName} | ${this.patientFullName || ''}
  </div>
  <table class="lab-summary-table">
    <thead>

    </thead>
    <tbody>
      ${dataRows}
    </tbody>
  </table>
</body>
</html>
`;
    }



//    generatePrintHtml_Transpose(): string {
//        const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';
//        const labData = this.arrlabdetails.slice(1);  // Skip header if needed

//        // Header row: "Field" + Value 1, Value 2, ...
//     //   const headerRow = ['<th class="header-cell">Field</th>', ...labData.map((_, i) => `<th class="header-cell">Value ${i + 1}</th>`)].join('');

//        // Data rows: first column is field name, followed by values
//        const dataRows = this.cols.map(col => {
//            const fieldName = this.Getheader(col.header);
//            const values = labData.map(item => `<td>${this.Getfield(item[col.field])}</td>`).join('');
//            return `<tr><th class="first-col">${fieldName}</th>${values}</tr>`;
//        }).join('');

//        const now = new Date();
//        const formattedDate = now.toLocaleString('en-IN', {
//            day: '2-digit', month: 'long', year: 'numeric',
//            hour: '2-digit', minute: '2-digit', hour12: true
//        });

//        return `
//<!DOCTYPE html>
//<html lang="en">
//<head>
//  <meta charset="UTF-8">
//  <title>Print::Labs List</title>
//  <style>
//    body {
//      font-family: Arial, sans-serif;
//      margin: 10mm;
//      font-size: 8pt;
//      background-color: #fff;
//    }

//    #timestamp {
//      font-style: italic;
//      font-size: 7pt;
//      margin-bottom: 10px;
//    }

//    .lab-summary-table {
//      width: 100%;
//      border-collapse: collapse;
//      table-layout: fixed;
//      word-wrap: break-word;
//    }

//    .lab-summary-table th, .lab-summary-table td {
//      border: 1px solid #000;
//      padding: 4px;
//      text-align: left;
//      vertical-align: top;
//      word-break: break-word;
//    }

//    .header-cell {
//      background-color: #007bff;
//      color: #fff;
//      font-weight: bold;
//    }

//    .first-col {
//      background-color: #f2f2f2;
//      font-weight: bold;
//    }

//    #txtpatient {
//      font-weight: bold;
//      margin: 6px 0 12px 0;
//    }

//    @media print {
//      @page {
//        size: A4 landscape;
//        margin: 10mm;
//      }
//      body {
//        margin: 0;
//      }
//    }
//  </style>
//</head>
//<body>
//  <div id="timestamp">Printed on: ${formattedDate}</div>
//  <div id="txtpatient">
//    Labs: ${safeTestName} | ${this.patientFullName || ''}
//  </div>
//  <table class="lab-summary-table">

//    <tbody>
//      ${dataRows}
//    </tbody>
//  </table>
//</body>
//</html>
//`;
//    }

    //Column Break Layout Design ::
  //  generatePrintHtml_ColumnBreak(): string
  //  {

  //      const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';
  //      const maxColsPerTable = 10;// environment.noOfColumnsInLabList;
  //      const colGroups: { header: string; field: string; width?: string }[][] = [];
  //      for (let i = 0; i < this.cols.length; i += maxColsPerTable) {
  //          colGroups.push(this.cols.slice(i, i + maxColsPerTable));
  //      }
  //      const generateTableHTML = (columns: typeof this.cols, tableId: string) => {
  //          const headers = columns.map(col => `<th style="width: ${col.width || (100 / columns.length) + '%'};"> ${this.Getheader(col.header)} </th>`).join('');
  //          const rows = this.arrlabdetails.slice(1).map((item, index) => `<tr>${columns.map(col => `<td>${this.Getfield(item[col.field])}</td>`).join('')}</tr>`).join('');
  //          return `<table id="${tableId}">
  //          <thead><tr>${headers}</tr></thead>


  //          <tbody>${rows}</tbody></table>`;
  //      };
  //      const tablesHTML = colGroups.map((group, index) => generateTableHTML(group, `Labs_print_table_tbody${index + 1}`)).join('');
  //      const now = new Date();
  //      const formattedDate = now.toLocaleString('en-IN', { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true });
  //      const html = `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"> <title>Print::Labs List</title>
  //    <style> body {
  //        font-family: Arial, sans-serif;
  //        margin: 10mm;
  //        font-size: 7pt;
  //        background-color: #fff;
  //      }
  //      #printHeader {
  //        display: flex;
  //        justify-content: space-between;
  //        align-items: center;
  //        margin-bottom: 10px;
  //      }
  //      #printHeader img {
  //        height: 30px;
  //      }
  //      #txtpatient {
  //        display: flex;
  //        justify-content: space-between;
  //        margin-bottom: 10px;
  //        padding: 5px;
  //        font-weight: bold;
  //        font-size: 8pt;
  //      }
  //      #timestamp {
  //        font-style: italic;
  //        font-size: 7pt;
  //        margin-bottom: 10px;
  //        text-align: right;
  //      }
  //      table {
  //        width: 100%;
  //        border-collapse: collapse;
  //        table-layout: fixed;
  //        margin-bottom: 20px;
  //        page-break-inside: avoid;
  //      }
  //      th, td {
  //        border: 1px solid #000;
  //        padding: 3px;
  //        font-size: 7pt;
  //        word-wrap: break-word;
  //        text-align: left;
  //      }

  //      tr {
  //      page-break-inside: avoid;
  //    }
  //    .section {
  //      page-break-inside: avoid;
  //      margin-bottom: 12px;
  //    }
  //      th {
  //        background-color: #d3d3d3;
  //      }
  //      tr:nth-child(odd) {
  //        background-color: #fff;
  //      }
  //      tr:nth-child(even) {
  //        background-color: #f0f0f0;
  //      }
  //      @media print {
  //        @page {
  //          size: A4 landscape;
  //          margin: 10mm;
  //        }
  //        body {
  //          margin: 0;
  //        }
  //        table, tr, td, th {
  //          page-break-inside: avoid;
  //          page-break-after: auto;
  //        }
  //      }
  //    </style>
  //  </head><body>

  //    <div id="printHeader">
  //       <div id="timestamp">Printed on: ${formattedDate}</div>
  //    </div>

  //    <div id="txtpatient">

  //    <div>Labs :${safeTestName || ''}</div>

  //      <div>${this.patientFullName || ''}</div>
  //    </div>
  //    ${tablesHTML}
  //  </body>
  //  </html>
  //`;
  //      return html;
    //  }





    generatePrintHtml_ColumnBreak(): string {
        const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';
        const maxColsPerTable = 10;

        // Always include first column
        const firstCol = this.cols[0];
        const remainingCols = this.cols.slice(1);

        // Chunk remaining columns into groups
        const colGroups: { header: string; field: string; width?: string }[][] = [];
        for (let i = 0; i < remainingCols.length; i += maxColsPerTable - 1) {
            const chunk = remainingCols.slice(i, i + (maxColsPerTable - 1));
            colGroups.push([firstCol, ...chunk]); // Add first column to every chunk
        }

        // Generate HTML for each table
        const generateTableHTML = (columns: typeof this.cols, tableId: string) => {
            const headers = columns.map(col =>
                `<th style="width: ${col.width || (100 / columns.length) + '%'};">${this.Getheader(col.header)}</th>`
            ).join('');

            const rows = this.arrlabdetails.slice(1).map((item, rowIndex) =>
                `<tr>${columns.map(col =>
                    `<td>${this.Getfield(item[col.field])}</td>`
                ).join('')}</tr>`
            ).join('');

            return `
      <div class="section">
        <table id="${tableId}">
          <thead><tr>${headers}</tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>`;
        };

        const tablesHTML = colGroups.map((group, index) =>
            generateTableHTML(group, `Labs_print_table_tbody${index + 1}`)
        ).join('');

        const now = new Date();
        const formattedDate = now.toLocaleString('en-IN', {
            day: '2-digit', month: 'long', year: 'numeric',
            hour: '2-digit', minute: '2-digit',
            hour12: true
        });

        return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <title>Print::Labs List</title>
  <style>
    body {
      font-family: Arial, sans-serif;
      margin: 10mm;
      font-size: 7pt;
      background-color: #fff;
    }

    #printHeader {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    #txtpatient {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      padding: 5px;
      font-weight: bold;
      font-size: 8pt;
    }

    #timestamp {
      font-style: italic;
      font-size: 7pt;
      text-align: right;
    }

    .section {
      margin-bottom: 12px;
      page-break-inside: avoid;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      table-layout: fixed;
      page-break-inside: avoid;
      margin-bottom: 20px;
    }

    th, td {
      border: 1px solid #000;
      padding: 3px;
      font-size: 7pt;
      word-wrap: break-word;
      text-align: left;
    }

    th {
      background-color: #d3d3d3;
    }

    tr:nth-child(odd) {
      background-color: #fff;
    }

    tr:nth-child(even) {
      background-color: #f0f0f0;
    }

    @media print {
      @page {
        size: A4 landscape;
        margin: 10mm;
      }

      body {
        margin: 0;
      }

      table, tr, td, th {
        page-break-inside: avoid;
        page-break-after: auto;
      }
    }
  </style>
</head>
<body>
  <div id="printHeader">
    <div id="timestamp">Printed on: ${formattedDate}</div>
  </div>

  <div id="txtpatient">
    <div>Labs: ${safeTestName || ''}</div>
    <div>${this.patientFullName || ''}</div>
  </div>

  ${tablesHTML}

 
</body>
</html>`;
    }





    //Vertical Layout Design ::
    generatePrintHtml_Vertical(): string {

        const safeTestName = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizedTestName) || '';


        const source = document.getElementById('PrintLabs_List') as HTMLElement | null;
        if (!source) {
            console.error('#PrintLabs_List not found.');
            return;
        }

        /* -------------------------------------------------------
         * 2. Helper that turns ONE record into HTML
         *    - Left  column = field header
         *    - Right column = field value
         * ----------------------------------------------------- */
        const generateRecordHTML = (item: any, recordIndex: number): string => {
            const rows = this.cols.map(col => `
        <tr>
          <th>${this.Getheader(col.header)}</th>
          <td>${this.Getfield(item[col.field])}</td>
        </tr>
      `).join('');

            /* Wrap each record in a div so we get some spacing */
            return `
      <div class="record-block">        
        <table class="record-table">
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
        };

        /* -------------------------------------------------------
         * 3. Create HTML for EVERY record
         *    slice(1) → skips the very first row if you don’t want it
         * ----------------------------------------------------- */
        const recordsHTML = this.arrlabdetails
            .slice(1)               // remove if you actually need row 0
            .map(generateRecordHTML)
            .join('');

        /* -------------------------------------------------------
         * 4. Common header info: timestamp + patient / test name
         * ----------------------------------------------------- */
        const now = new Date();
        const formattedDate = now.toLocaleString('en-IN', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });

        /* -------------------------------------------------------
         * 5. Build the COMPLETE HTML document as one template‑literal
         * ----------------------------------------------------- */
        const html = /* html */`
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <title>Print::Labs List</title>
      <style>
        /* ---------- Base styles ---------- */
        body       { font-family: Arial, sans-serif; font-size: 8pt; margin: 10mm; }
        h4         { margin: 0 0 4px 0; font-size: 9pt; }
        .record-block { margin-bottom: 16px; page-break-inside: avoid; }

        /* Table formatting */
        .record-table         { width: 100%; border-collapse: collapse; }
        .record-table th      { width: 30%; background: #f0f0f0; text-align: left; }
        .record-table th,
        .record-table td      { border: 1px solid #000; padding: 4px; word-break: break-word; }

        /* Print settings */
        @media print {
          @page { size: A4 portrait; margin: 10mm; }
          body  { margin: 0; }
          .record-block { page-break-inside: avoid; }
        }
      </style>
    </head>
    <body>
      <div id="timestamp">Printed on: ${formattedDate}</div>
      <div id="txtpatient" style="font-weight:bold; margin:6px 0 12px 0;">
         <span>Labs: ${safeTestName || ''}</span>

        <span>${this.patientFullName || ''}</span>
      </div>

      ${recordsHTML}
    </body>
    </html>
  `;      
   return html;
    }
 
    closeDialog(): void {
        this.printLayoutDesign = false;
        this.printlayout = 'layout2';
    }



}

    


